import { useState } from "react";
import { debateList } from "../../../mocks/news";

export default function Debate() {
  const [choice, setChoice] = useState<Record<number, "A" | "B">>({});
  const [cast, setCast] = useState<Record<number, boolean>>({});

  const handleVote = (id: number, side: "A" | "B") => {
    if (cast[id]) return;
    setChoice((c) => ({ ...c, [id]: side }));
    setCast((c) => ({ ...c, [id]: true }));
  };

  return (
    <section id="debate" className="scroll-mt-20 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-px w-6 bg-primary-400" aria-hidden="true" />
              一键表态
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              网友热议焦点
            </h2>
            <p className="mt-3 max-w-2xl text-sm text-foreground-600">
              围观归围观，立场要有。挑一个正在发酵的话题投出你的态度，看看大家怎么看。
            </p>
          </div>
          <span className="flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-600 ring-1 ring-background-200">
            <i className="ri-account-circle-line text-primary-600" aria-hidden="true" />
            {Object.keys(cast).length} 个话题已表态
          </span>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-3">
          {debateList.map((d) => {
            const my = choice[d.id];
            const casted = cast[d.id];
            return (
              <article
                key={d.id}
                className="flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-card"
              >
                <div className="flex items-center justify-between border-b border-background-100 px-5 py-3">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-700">
                    热议中
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-team-line text-accent-600" aria-hidden="true" />
                    {d.voters} 万人参与
                  </span>
                </div>
                <div className="flex flex-1 flex-col px-5 py-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-900">
                    {d.title}
                  </h3>

                  {casted ? (
                    <div className="mt-5 space-y-3">
                      {(["A", "B"] as const).map((side) => {
                        const isMine = my === side;
                        const pct = side === "A" ? d.rateA : 100 - d.rateA;
                        const label = side === "A" ? d.takeA : d.takeB;
                        return (
                          <div
                            key={side}
                            className={`rounded-xl px-4 py-3 ${
                              isMine
                                ? "bg-primary-100 ring-1 ring-primary-300"
                                : "bg-background-100"
                            }`}
                          >
                            <div className="flex items-center justify-between text-sm">
                              <span className="flex items-center gap-2 text-foreground-800">
                                {isMine && (
                                  <i className="ri-checkbox-circle-fill text-primary-600" aria-hidden="true" />
                                )}
                                {label}
                              </span>
                              <span className="font-heading font-bold tabular-nums text-foreground-800">
                                {pct}%
                              </span>
                            </div>
                            <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                              <div
                                className={`h-full rounded-full ${isMine ? "bg-primary-500" : "bg-foreground-400"}`}
                                style={{ width: `${pct}%` }}
                              />
                            </div>
                          </div>
                        );
                      })}
                      <p className="pt-1 text-center text-xs text-foreground-500">
                        已投票 · 感谢参与，理性讨论
                      </p>
                    </div>
                  ) : (
                    <div className="mt-5 space-y-2.5">
                      <button
                        type="button"
                        onClick={() => handleVote(d.id, "A")}
                        className="w-full whitespace-nowrap rounded-xl bg-primary-50 px-4 py-3 text-sm font-medium text-primary-800 ring-1 ring-primary-200 transition-colors hover:bg-primary-100"
                      >
                        {d.takeA}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleVote(d.id, "B")}
                        className="w-full whitespace-nowrap rounded-xl bg-secondary-50 px-4 py-3 text-sm font-medium text-secondary-800 ring-1 ring-secondary-200 transition-colors hover:bg-secondary-100"
                      >
                        {d.takeB}
                      </button>
                    </div>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}